<!-- ConventionBadge.vue -->
<script setup lang="ts">
import type { HTMLAttributes } from "vue"
import { computed } from "vue"
import { type BadgeVariants, badgeVariants } from "@/components/ui/badge"
import { cn } from "@/lib/utils"

type ConventionUserBadgeVariants = BadgeVariants["variant"] | "active" | "pending" | "deactivated"

const props = defineProps<{
  variant?: ConventionUserBadgeVariants
  class?: HTMLAttributes["class"]
}>()

const ConventionUserBadgeVariants = computed(() => {
  const baseVariants = badgeVariants({ variant: props.variant as BadgeVariants["variant"] })

  // Aggiungi le nuove varianti
  const newVariants = {
    active: "border-transparent bg-primary text-primary-foreground shadow hover:bg-primary/80",
    pending: "border-transparent bg-success text-success-foreground shadow hover:bg-success/80",
    deactivated: "border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80"
  }

  // Combina le varianti di base con le nuove
  return cn(
    baseVariants,
    props.variant && props.variant in newVariants ? newVariants[props.variant as keyof typeof newVariants] : "",
    props.class
  )
})
</script>

<template>
  <div :class="ConventionUserBadgeVariants">
    <slot />
  </div>
</template>
